export default "__VITE_ASSET__U7QNPe0b__"